/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/small-triangle-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3 5l5 6 5-6z" _fill="#272c33"/>'
  }
})
